import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faExternalLinkSquare} from '@netx/core-icons';
import {canPublishAsset} from '../enablers';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionSharePublishBrightcoveIcon = faExternalLinkSquare;

/**
 * Asset share publish
 * @param params
 * @returns Action
 */
export const assetActionSharePublishBrightcove = (
	asset?: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-share-publish-brightcove',
	cb: () => dispatcher.trigger(ASSET_EVENT.SHARE_PUBLISH_BRIGHTCOVE, asset),
	enableTest: () => canPublishAsset(asset, 'Brightcove'),
	// icon: assetActionSharePublishBrightcoveIcon,
	get label() {
		return 'Brightcove';
	},
	...params,
});

export default assetActionSharePublishBrightcove;
